module.exports = __webpack_public_path__ + "img/pdf2.a80e1b5a.jpg";